import {ProjectList} from './ProjectList.jsx';
import {AboutMe} from './AboutMe.jsx';
import Photos from './Photos.jsx';
import {Contact} from './Contact.jsx';
import {Medium} from './Medium.jsx';
import {Footer} from './Footer.jsx';
import {MainSlider} from './MainSlider.jsx';

export {MainSlider, ProjectList, AboutMe, Photos, Contact, Medium, Footer};



// WEBPACK FOOTER //
// ../components/sections/index.js